module.exports = __webpack_public_path__ + "static/media/failure.44db2cdb.wav";